import useAuth from './hooks/useAuth';
import Header from './components/shared/Header';
import Sidebar from './components/shared/Sidebar';
import MainContent from './components/shared/MainContent';
import { Outlet } from 'react-router-dom';

function App() {
  const {auth} = useAuth();

  return (
    <>
      {auth?.token && (
        <>
          <Header />
          <div className='container-fluid'>
            <div className='row'>
              <Sidebar />
              <MainContent>
                <Outlet />
              </MainContent>
            </div>
          </div>
        </>
      )} 
      {!auth?.token && <Outlet />}   
    </>
  );
}

export default App;
